import { ExperimentState } from 'modules/graphql';
import { StatusBadge } from 'modules/experiments/components/ui';
import { TableCell } from './Styled';

type StatusCellProps = {
  status: ExperimentState;
};

export const StatusCell = ({ status }: StatusCellProps) => {
  return (
    <TableCell>
      <StatusBadge state={status} />
    </TableCell>
  );
};
